module.exports = __webpack_public_path__ + "static/media/nav-purchase.76812d87.svg";